/* eslint-env browser */
import React, { FC } from 'react';
import AUCollapsibleComponent from './AUCollapsibleComponent';

type Props = {
  names: { name: string }[];
  address: string;
}

const BuildingCardComponent: FC<Props> = ({
  names, address,
}) => {
  const persons: IEmployee[] = [];
  const renderPersons = persons.map((p) => (
    <li key={p.fullName}>
      <button
        type="button"
        onClick={(e) => {
          e.preventDefault();
          // personClick([p]);
        }}
      >
        {p.fullName}
      </button>
    </li>
  ));

  return (
    <div className="bld-card">
      <h2>
        <strong>
          {names[0].name}
        </strong>
      </h2>
      {
        (names.length > 1) && (
          <h4>
            <strong>
              {names.slice(1).map((n) => n.name).join(', ')}
            </strong>
          </h4>
        )
      }
      <p>
        {address}
      </p>
      {
        persons.length > 0 && (
          <AUCollapsibleComponent
            collapsed
            header="Personer i bygningen"
            level={3}
          >
            <div className="person-list">
              <ul>
                {renderPersons}
              </ul>
            </div>
          </AUCollapsibleComponent>
        )
      }
      <hr />
    </div>
  );
};

BuildingCardComponent.displayName = 'BuildingCardComponent';
export default BuildingCardComponent;
